export default {"src":"/_next/static/media/spotlight-bg.ca693c14.svg","height":448,"width":335,"blurWidth":0,"blurHeight":0};